export default {
  namespaced: true,
  state: {
    auth: null,
  },
  mutations: {
    setAuthData (state, data) {
      state.auth = data;
    },
  },
  actions: {
    pdfGen({ commit, dispatch, state }) {

      let auth = state.auth;

      if (state.auth === null) {
        return dispatch('pdfGenAuth').then(response => {
          commit('setAuthData', response.data);
          return dispatch('pdfGen');
        });
      }

      return dispatch('pdfGenCreate', auth);
    },
    pdfGenAuth() {
      return this.$axios({
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Headers': 'Authorization, Content-Type',
        },
        method: 'POST',
        url: 'https://pdfmakerstage.wpengine.com/wp-json/jwt-auth/v1/token',
        data: {
          username: 'financial_disclosure',
          password: '@^M8BIe%AS&KSB7YZBxzQ49Z',
        },
      });
    },
    // eslint-disable-next-line no-unused-vars
    pdfGenCreate ({ commit }, auth) {
      return this.$axios({
        headers: {
          'Authorization': `Bearer ${auth.token}`,
        },
        method: 'POST',
        url: 'https://pdfmakerstage.wpengine.com/wp-json/pdf/v1/gen',
        data: {
          form_id: auth.forms[0].form_id,
          pdf_id: auth.forms[0].form_pdfs[0].id,
          user_id: auth.user_id,
          pdf_data: {
            input_1: 'Something',
          },
        },
      });
    },
  },
};
